<script setup lang="ts">
import ClipboardCopy from 'pejer/src/components/Table/core/ClipboardCopy.vue';
import { cn } from '../../../lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip';

const props = defineProps<{
  id: string | number | Record<string, number | string>
  pathName: string
  content?: string | number
  class?: string
}>()
</script>
<template>
   <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <RouterLink
        class="w-full hover:underline"
        @click.stop.prevent
          v-if="id"
          :to="{
            name: pathName,
            params: typeof id === 'object' ? id : { id },
          }"
        >
        <ClipboardCopy :value="content">
            <slot/>
        </ClipboardCopy>
        </RouterLink>
        <span
          v-else
          class="whitespace-nowrap overflow-hidden text-ellipsis w-full"
          :class="
            cn(props.class, content ? '' : 'italic text-xs text text-gray-500 ')
          "
        >
          <ClipboardCopy :value="content " >
            {{ content || '...' }}
          </ClipboardCopy>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p class="text-sm">{{ props.content }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
    
</template>
